/* eslint-disable react-hooks/exhaustive-deps */
import filterImg from "assets/pictures/filter.png";
import hrView from "assets/pictures/hr-view.svg";
import squareView from "assets/pictures/square-view.svg";
import { useState, useMemo, useEffect, Fragment } from "react";
import StickyBox from "react-sticky-box";
import "assets/css/App.css";
import "assets/css/index.css";
import Footer from "components/Footer";
import Header from "components/Header";
import Pagination from "components/pagination/Pagination";
import OffcanvasFilter from "components/products/OffcanvasFilter";
import {
  ProductCard,
  ProductCardListView,
  ProductQuery,
  Sidebar,
  Slider,
} from "components/products";
import { useShop } from "hooks";
import { useNavigate, useSearchParams } from "react-router-dom";

const PageSize = 30;

const Products = () => {
  const { isLoggedIn, info } = useShop();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [gridView, setGridView] = useState(true);
  const { data = [] } = ProductQuery(); // Add default empty array

  // Initialize category_arr using useMemo to prevent recalculation
  const category_arr = useMemo(() => {
    return data.reduce((acc, product) => {
      if (product?.category?.name && product?.category?.id) {
        acc[product.category.name] = product.category.id;
      }
      return acc;
    }, {});
  }, [data]);

  const shop_id = info?.id || 0;

  // Calculate current page data
  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, data]);

  // Handle view toggle
  const changeGridView = () => {
    setGridView((prev) => !prev);
  };

  // Redirect if not logged in
  useEffect(() => {
    if (!isLoggedIn && window.location.pathname !== "/") {
      navigate("/");
    }
  }, [isLoggedIn, navigate]);

  // Handle navigation with search params
  const handleNavigate = (key, value) => {
    const params = new URLSearchParams(searchParams);
    
    if (key === "price") {
      params.set("price_min", value[0]);
      params.set("price_max", value[1]);
    } else {
      params.set(key, value);
    }

    navigate(`/products?${params.toString()}`);
  };

  return (
    <Fragment>
      <Header />
      {shop_id && !searchParams.toString() && <Slider shop_id={shop_id} />}
      
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 col-md-3 sidebar-content">
            <StickyBox offsetTop={10} offsetBottom={40}>
              <div id="side">
                {shop_id && (
                  <Sidebar shop_id={shop_id} category={category_arr} />
                )}
              </div>
            </StickyBox>
          </div>

          <div className="col-lg-10 col-md-9">
            <div className="main-content">
              <h1 className="m-4">Product list</h1>

              <div className="container-fluid">
                <div className="row main-row">
                  <div className="row sorting-section">
                    <div className="container mt-5 mb-5">
                      <section id="tabs">
                        {/* Desktop View */}
                        <div
                          className="nav nav-tabs d-none d-md-flex"
                          id="nav-tab"
                          role="tablist"
                        >
                          <div className="d-flex align-items-center">
                            <p className="pe-2 mb-0">VIEW AS</p>
                            <img
                              className="mx-1 pe-2"
                              style={{ height: 20, cursor: "pointer" }}
                              src={squareView}
                              alt="Grid view"
                              onClick={changeGridView}
                            />
                            <img
                              className=""
                              style={{ height: 20, cursor: "pointer" }}
                              src={hrView}
                              alt="List view"
                              onClick={changeGridView}
                            />
                          </div>
                          <div className="box2 text-center">
                            <p>ITEMS PER PAGE: {currentTableData.length}</p>
                          </div>
                          <div className="box3">
                            <select
                              className="form-select form-filter"
                              aria-label="Sort products"
                              onChange={(e) =>
                                handleNavigate("sort_by", e.target.value)
                              }
                              defaultValue=""
                            >
                              <option value="">Default Sorting</option>
                              <option value="popularity">Popularity</option>
                              <option value="low">Price High to Low</option>
                              <option value="high">Price Low to High</option>
                            </select>
                          </div>
                          <div className="box4">
                            <p>
                              <span
                                data-bs-toggle="offcanvas"
                                data-bs-target="#filterOffcanvas"
                              >
                                <img src={filterImg} width="10%" alt="Filter" />
                                &nbsp;Filter
                              </span>
                            </p>
                          </div>
                        </div>

                        {/* Mobile View */}
                        <div className="nav nav-tabs d-flex d-md-none">
                          <div className="box3">
                            <select
                              className="form-select form-filter"
                              aria-label="Sort products"
                              onChange={(e) =>
                                handleNavigate("sort_by", e.target.value)
                              }
                              defaultValue=""
                            >
                              <option value="">Default Sorting</option>
                              <option value="popularity">Popularity</option>
                              <option value="low">Price High to Low</option>
                              <option value="high">Price Low to High</option>
                            </select>
                          </div>
                          <div className="box4">
                            <p>
                              <span
                                data-bs-toggle="offcanvas"
                                data-bs-target="#filterOffcanvas"
                              >
                                <img src={filterImg} width="10%" alt="Filter" />
                                &nbsp;Filter
                              </span>
                            </p>
                          </div>
                        </div>

                        <OffcanvasFilter shop_id={shop_id} category={category_arr} />

                        <div className="tab-content" id="nav-tabContent">
                          <div
                            className={`tab-pane fade ${gridView ? "show active" : ""}`}
                            id="nav-home"
                            role="tabpanel"
                            aria-labelledby="nav-home-tab"
                          >
                            <div className="container mt-4 mb-4">
                              <div className="row">
                                {currentTableData.length > 0 ? (
                                  currentTableData.map((product, idx) => (
                                    <ProductCard
                                      key={product.id || idx}
                                      product={product}
                                      category={category_arr}
                                    />
                                  ))
                                ) : (
                                  <div className="alert">No products found</div>
                                )}
                              </div>
                              <div className="page-number">
                                <Pagination
                                  totalCount={data.length}
                                  currentPage={currentPage}
                                  pageSize={PageSize}
                                  onPageChange={(page) => {
                                    setCurrentPage(page);
                                    window.scrollTo(0, 500);
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            className={`tab-pane fade ${!gridView ? "show active" : ""}`}
                            id="nav-prestige"
                            role="tabpanel"
                            aria-labelledby="nav-prestige-tab"
                          >
                            <div className="container mt-4 mb-4">
                              {currentTableData.length > 0 ? (
                                currentTableData.map((product, idx) => (
                                  <ProductCardListView
                                    key={product.id || idx}
                                    product={product}
                                  />
                                ))
                              ) : (
                                <div className="alert">No products found</div>
                              )}
                              <div className="page-number">
                                <Pagination
                                  totalCount={data.length}
                                  currentPage={currentPage}
                                  pageSize={PageSize}
                                  onPageChange={(page) => {
                                    setCurrentPage(page);
                                    window.scrollTo(0, 500);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        {Object.keys(category_arr).length > 0 && (
          <Footer category={category_arr} />
        )}
      </div>
    </Fragment>
  );
};

export default Products;